import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AddCharts, GetChartsAvailableByDashboardId } from '../../../reduxToolkit/Graphs/GraphsApi';
import { useEffect } from 'react';
import { GetGraphByUserId } from './../../../reduxToolkit/Graphs/GraphsApi';
import { toast } from 'react-toastify';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityAddGraphModal = ({ dashboardIdSection, sectionPosition, userId, onHide, t }) => {
    const dispatch = useDispatch();
    const [selectedGraph, setSelectedGraph] = useState('');
    const [availableCharts, setAvailableCharts] = useState([]);
    const [selectedChartType, setSelectedChartType] = useState('');
    const [emptyFields, setEmptyFields] = useState(false);

    // Disables create button if chart type or graph is not selected
    const isCreateButtonDisabled = !selectedChartType || !selectedGraph;
    // Updates selected chart type when user changes selection
    const handleChartTypeChange = (event) => setSelectedChartType(event.target.value);
    // Updates selected graph ID
    const handleGraphChange = (id) => setSelectedGraph(id);
    // Fetches available charts for a given dashboard ID when it changes
    useEffect(() => {
        if (dashboardIdSection) {
            dispatch(GetChartsAvailableByDashboardId(dashboardIdSection)).then(
                ({
                    payload: {
                        data: { data, success },
                    },
                }) => {
                    if (success) {
                        setAvailableCharts(data);
                    }
                },
            );
        }
    }, [dispatch, dashboardIdSection]);
    // Handles the creation of a chart within the dashboard section
    const handleCreate = async () => {
        const body = {
            charts: [{ chartType: selectedChartType, id: selectedGraph, position: sectionPosition }],
            dashboardId: dashboardIdSection,
        };

        const result = await dispatch(AddCharts({ body }));

        if (result.payload?.data?.success) {
            await dispatch(GetGraphByUserId(userId));
            toast.success(t('has_been_created_successfully'));
            onHide(); 
        }
    };

    return {
        emptyFields,
        setEmptyFields,
        handleCreate,
        isCreateButtonDisabled,
        selectedChartType,
        handleChartTypeChange,
        selectedGraph,
        handleGraphChange,
        availableCharts,
    };
};
export default FunctionalityAddGraphModal;
